import { Set } from 'immutable';
import { Validator, cannotBeEmptyString, cannotBeHigherThan, cannotBeNullOrUndefined, mustBeValidEmail, unknown, valid } from "../../../../../../Shared/validationUtils";
import { Field, LocationOptionData } from "./LocationOptionFormState";
import { atLeastOneSlotMustBeSelected } from "./TimeslotInput/TimeslotInputState";
export const validateField = (props: ValidatorProps) => {
  const validator = buildValidator(props);
  return <Field extends keyof LocationOptionData>(field: Field) =>
    (value: LocationOptionData[Field]) => {
      const fieldValidators = validator[field] as Validator<LocationOptionData[Field]>[]

      let result = unknown

      for (let i = 0; i < fieldValidators.length; i++) {
        result = fieldValidators[i](value)
        if (result.status != 'unknown') break
      }

      return result.status == "unknown" ? valid : result
    }
}

export interface ValidatorProps {
  maxParticipants: number
}

const buildValidator: (props: ValidatorProps) => { [k in Field]: Validator<LocationOptionData[k]>[] } = (props: ValidatorProps) => ({
  firstName: [],
  infix: [],
  lastName: [
    cannotBeEmptyString('Achternaam mag niet ontbreken')
  ],
  companyName: [],
  email: [
    cannotBeEmptyString('E-mailadres mag niet ontbreken'),
    mustBeValidEmail('E-mailadres lijkt niet geldig')
  ],
  phoneNumber: [],
  date: [
    cannotBeNullOrUndefined('Datum mag niet ontbreken')
  ],
  seatplanId: [
    cannotBeNullOrUndefined('Opstelling mag niet ontbreken')
  ],
  participants: [
    cannotBeHigherThan(props.maxParticipants, 'Het aantal deelnemers kan niet groter zijn dan de capaciteit van de gekozen opstelling')
  ],
  timeslots: [
    atLeastOneSlotMustBeSelected('Kies minimaal één dagdeel')
  ],
  means: [],
  note: []
})

const fast: Field[] = ['participants', 'timeslots']
export const fastFields: Set<Field> = Set<Field>(fast)